import { render, staticRenderFns } from "./spot-detail.vue?vue&type=template&id=fbf91c26&scoped=true&"
import script from "./spot-detail.vue?vue&type=script&lang=js&"
export * from "./spot-detail.vue?vue&type=script&lang=js&"
import style0 from "./spot-detail.vue?vue&type=style&index=0&id=fbf91c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf91c26",
  null
  
)

export default component.exports